import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { IconGeneratorPage } from './IconGeneratorPage';

/**
 * Arche wrapper for Icon Generator — provides ArcheLayout with sidebar
 * and handles sub-routing.
 */
export function IconGeneratorArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<IconGeneratorPage />} />
      </Routes>
    </ArcheLayout>
  );
}
